export default {
  AUTH_LOGIN: 'AUTH_LOGIN',
  RESET_PASSWORD: 'RESET_PASSWORD',
  FORGOT_PASSWORD: 'FORGOT_PASSWORD',
  GET_USER_DETAILS: 'GET_USER_DETAILS',
  GET_USER_REPORT_ACCESS: 'GET_USER_REPORT_ACCESS',
}
